import { createFileRoute, redirect } from '@tanstack/react-router';
import { FeatureFlag, TextKey } from '@mews-commander/enums';
import { MewsTeam, RouteType } from '@mews/enums';
import { ProfileTabActions } from '@mews-commander/modules/src/modules/customerProfile';
import { useEnterpriseBuildLocation } from '@mews-commander/ui';
import { BackendPage, getBackendPageUrl } from '@mews-commander/modules';
import { getCustomerNameForDocumentTitle } from '../-utils/getCustomerNameForDocumentTitle';

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Customer/$id/_pageLayout/Detail')({
    beforeLoad: ({ context: { featureFlagService }, params }) => {
        if (!featureFlagService.hasFlag(FeatureFlag.newCustomerPageRouteStructureEnabled)) {
            throw redirect({
                to: '/$currentEnterpriseId/Customer/Detail/$id',
                params,
                search: { EnterpriseId: params.currentEnterpriseId },
            });
        }
    },
    loader: async ({ params: { id }, context: { ensureQueryData } }) =>
        await getCustomerNameForDocumentTitle({ ensureQueryData, id }),
    component: Component,
    staticData: {
        owner: MewsTeam.Accounts,
        type: RouteType.Backend,
        title: TextKey.Profile,
    },
});

function Component() {
    const params = Route.useParams();
    const otherSearch = Route.useSearch();
    const buildLocation = useEnterpriseBuildLocation();

    const search = {
        EnterpriseId: params.currentEnterpriseId,
        ...otherSearch,
    };

    const legacyPathname = buildLocation({ to: 'Customer/Detail/$id', params }).href;

    return (
        <>
            <ProfileTabActions customerId={params.id} />
            <BackendPage
                absolutePosition={false}
                url={getBackendPageUrl({ pathname: legacyPathname, search })}
                layout="Empty"
            />
        </>
    );
}
